import { createParser } from 'nuqs';
import { convertClientDateTimeToServerDateTime } from '../date';

export type SieveFilterOperator =
	| '=='
	| '!='
	| '>'
	| '<'
	| '>='
	| '<='
	| '@='
	| '_='
	| '_-='
	| '@!='
	| '!_='
	| '!_-='
	| '@=*'
	| '_=*'
	| '_-=*'
	| '==*'
	| '!=*'
	| '!@=*'
	| '!_=*';
export const sieveFilterOperators = [
	'==',
	'!=',
	'>',
	'<',
	'>=',
	'<=',
	'@=',
	'_=',
	'_-=',
	'@!=',
	'!_=',
	'!_-=',
	'@=*',
	'_=*',
	'_-=*',
	'==*',
	'!=*',
	'!@=*',
	'!_=*'
] as const;

// interface SieveDateFilterModel {
// 	name: string;
// 	value: Date;
// 	utc: boolean;
// 	operator: SieveFilterOperator;
// }

// interface SieveNonDateFilterModel {
// 	name: string;
// 	value: string | number | boolean | null;
// 	operator: SieveFilterOperator;
// }

// interface SieveCustomFilterModel {
// 	name: string;
// 	value: any;
// 	operator: SieveFilterOperator;
// }

export interface SieveFilterModel {
	name: string;
	value?: string | number | boolean | Date | null;
	operator?: SieveFilterOperator;
	utc?: boolean;
}

export const parseAsSieveFilters = createParser<SieveFilterModel[]>({
	parse: value => {
		if (!value) return null;
		// Format: "name==value,name2@=value2"
		return value
			.split(',')
			.map(segment => {
				const match = segment.match(/^(.+?)(==\*|!=\*|>=|<=|@=\*|_=\*|_-=\*|!@=\*|!_=\*|@!=|!_=|!_-=|@=|_=|_-=|==|!=|>|<)(.*)$/);
				if (!match) return null;
				return { name: match[1], operator: match[2] as SieveFilterOperator, value: match[3] };
			})
			.filter(Boolean) as SieveFilterModel[];
	},
	serialize: filters => filters.map(f => `${f.name}${f.operator ?? '=='}${f.value ?? ''}`).join(',')
});

export const buildFilters = (filters: SieveFilterModel[]): string[] => {
	if (!filters) {
		return [];
	}
	return filters.sort((a, b) => a.name.localeCompare(b.name)).map(x => buildFilter(x));
};

export function combineSieveValues(values: Array<string | number | boolean | null>): string {
	return values.join('|');
}

const buildFilter = (filter: SieveFilterModel): string => {
	if ((filter.value === null || filter.value === undefined) && !filter.operator) {
		return `${filter.name}`;
	}
	let filterValue =
		filter.value === null
			? 'null'
			: `${
					filter.value instanceof Date
						? !filter.utc
							? convertClientDateTimeToServerDateTime(filter.value)
							: filter.value.toISOString()
						: filter.value
			  }`;

	if (filterValue.indexOf(',') >= 0) {
		filterValue = filterValue.replace(/,/g, '\\,');
	}
	return `${filter.name}${filter?.operator ?? '@='}${filterValue}`;
};
